import {Request} from './Request';
import {ChargingRateUnitType} from '../enums/charging.rate.unit.type.enum';

/**
 *
 */
export class GetCompositeScheduleRequest implements Request {
    chargePointSelectList: string[];
    private duration: number;
    private connectorId: number;
    private chargingRateUnit: ChargingRateUnitType;

    constructor(chargePointSelectList: string[], chargingRateUnit?: ChargingRateUnitType, duration?: number,
                connectorId?: number) {
        this.chargePointSelectList = chargePointSelectList;
        this.duration = duration;
        this.connectorId = connectorId;
        this.chargingRateUnit = chargingRateUnit;
    }

    public toString = (): string => {
        return `GetCompositeScheduleRequest (duration: ${this.duration},
        connectorId: ${this.connectorId}, chargingRateUnit: ${this.chargingRateUnit}`;
    }


    get _duration(): number {
        return this.duration;
    }

    set _duration(value: number) {
        this.duration = value;
    }

    get connector_id(): number {
        return this.connectorId;
    }

    set connector_id(value: number) {
        this.connectorId = value;
    }

    get charging_rate_unit(): ChargingRateUnitType {
        return this.chargingRateUnit;
    }

    set charging_rate_unit(value: ChargingRateUnitType) {
        this.chargingRateUnit = value;
    }
}

/*

chargePointSelectList: JSON;EVB-P20261797;-
chargePointSelectList: 1
confKeyList: AllowOfflineTxForUnknownId
confKeyList: AuthorizationCacheEnabled
confKeyList: 1
commaSeparatedCustomConfKeys: key1,key2
csrf: 7f448777-54a3-4050-8ec1-9c696b0d47ef
 */
